import instance from '../instance'
export default class Project {
  static getMany(params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/spreadsheet-aggregate/project`,
      method: 'GET',
      params: params
    })
  }

  static create(params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/spreadsheet-aggregate/project`,
      method: 'POST',
      params: params
    })
  }

  static update(params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/spreadsheet-aggregate/project`,
      method: 'PUT',
      params
    })
  }

  static delete(params = []) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/spreadsheet-aggregate/project`,
      method: 'DELETE',
      params
    })
  }

  static get(id) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/spreadsheet-aggregate/project/${id}`,
      method: 'GET'
    })
  }

  static addMany(form) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/spreadsheet-aggregate/projects/import`,
      method: 'POST',
      data: form
    })
  }
}
